import React, { useEffect, useRef, useState } from 'react'
import GenericTabsComponent from '../../../genericComponents/GenericTabsComponent';
import DSRSummary from './DSRSummary';
import PANIndia from './PANIndia';
import AsmYtd from './AsmYtd';
import DivisionWiseSales from './DivisionWiseSales';
import DailySalesTracker from './DailySalesTracker';
import DailySalesTrackerCategoryLevel from './DailySalesTrackerCategoryLevel';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import Icons from '../../../assets/icons';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler, parseJSON } from '../../../helper/apiHelperFunctions';
import { scaleQuantile } from 'd3-scale';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { getPermissionKey } from '../../../helper/permissions';

const PREV_YEAR = (new Date()).getFullYear() - 1;
// ? Split "month" in cases where data is displayed month-wise
const splitMonth = data => {
    return data.map(item => {
        let temp = item?.month?.split("-");
        if (temp[1]) {
            return { ...item, month: temp[1] };
        }
        return item;
    });
}
// ? Make JSON for Store Grade Contribution - Sales Qty/Value
const getStoreGradeContri = (data, type) => {
    try {
        let temp = {}, storeGradeContri = [];
        data.forEach(item => {
            if (!temp?.[item?.grade]) {
                temp[item?.grade] = {};
            }
            temp[item?.grade] = {
                [item?.section]: item[type],
                ...temp[item?.grade]
            };
            delete temp[item?.grade]?.grade;
        });
        Object.keys(temp).forEach(key => {
            key != "null" && storeGradeContri?.push({
                grade: key,
                ...temp[key]
            });
        });
        return storeGradeContri;
    }
    catch (e) {
        console.log(e);
        return [];
    }
};
let colorScale = Function.prototype;

const PerformanceSummaryDashboard = (props) => {
    const dispatch = useDispatch()
    const digivendStore = useSelector(state => state.digivendStore)
    const generalStore = useSelector(state => state.generalStore)
    const [currentTab, setCurrentTab] = useState('dsrSummary')
    const [dashboardData, setDashboardData] = useState([])

    const tabsMapping = {
        dsrSummary: "SUMMARY",
        panIndia: "PAN_INDIA",
        asm: "ASM_YTD",
        divisionWiseSales: "PAN_INDIA",
        dailySalesTracker: "DSR_SUMMARY",
        dailySalesTrackerCategoryLevel: "DSR_SUMMARY_CATEGORY",
    }
    const exportToExcel = () => {
        const rows = dashboardData?.resource || [];
       if(currentTab==='dailySalesTrackerCategoryLevel'){
         if (!rows.length) return;
            const columns = [
                { key: 'assortmentName', label: 'Category' },
                { key: 'currDayQty', label: 'Daily Sales Qty' }, 
                { key: 'currDaySelling', label: 'Daily Net Sales' },
                { key: 'currDayMrp', label: 'Daily MRP Sales' }, 
                { key: 'currDayAsp', label: 'Daily ASP' },
                { key: 'currDayMdPct', label: 'Daily MD%' }, 
                { key: 'prevDayQty', label: 'Prev Day Qty' },
                { key: 'prevDaySelling', label: 'Prev Day Net Sales' }, 
                { key: 'prevDayMrp', label: 'Prev Day MRP' },
                { key: 'prevDayAsp', label: 'Prev Day ASP' }, 
                { key: 'prevDayMdPct', label: 'Prev Day MD%' },
                { key: 'dayGrowthPct', label: 'Day Growth%' },
                { key: 'wtdQty', label: 'WTD Qty' }, 
                { key: 'wtdSelling', label: 'WTD Net Sales' },
                { key: 'wtdMrp', label: 'WTD MRP Sales' }, 
                { key: 'wtdAsp', label: 'WTD ASP' },
                { key: 'wtdMdPct', label: 'WTD MD%' }, 
                { key: 'prevWtdQty', label: 'Prev WTD Qty' },
                { key: 'prevWtdSelling', label: 'Prev WTD Net Sales' }, 
                { key: 'prevWtdMrp', label: 'Prev WTD MRP' },
                { key: 'prevWtdAsp', label: 'Prev WTD ASP' }, 
                { key: 'prevWtdMdPct', label: 'Prev WTD MD%' },
                { key: 'wtdGrowthPct', label: 'WTD Growth%' },
                { key: 'mtdQty', label: 'MTD Qty' }, 
                { key: 'mtdSelling', label: 'MTD Net Sales' },
                { key: 'mtdMrp', label: 'MTD MRP Sales' }, 
                { key: 'mtdAsp', label: 'MTD ASP' },
                { key: 'mtdMdPct', label: 'MTD MD%' }, 
                { key: 'prevMtdQty', label: 'Prev MTD Qty' },
                { key: 'prevMtdSelling', label: 'Prev MTD Net Sales' }, 
                { key: 'prevMtdMrp', label: 'Prev MTD MRP' },
                { key: 'prevMtdAsp', label: 'Prev MTD ASP' }, 
                { key: 'prevMtdMdPct', label: 'Prev MTD MD%' },
                { key: 'mtdGrowthPct', label: 'MTD Growth%' },
                { key: 'ytdQty', label: 'YTD Qty' }, 
                { key: 'ytdSelling', label: 'YTD Net Sales' },
                { key: 'ytdMrp', label: 'YTD MRP Sales' }, 
                { key: 'ytdAsp', label: 'YTD ASP' },
                { key: 'ytdMdPct', label: 'YTD MD%' }, 
                { key: 'prevYtdQty', label: 'Prev YTD Qty' },
                { key: 'prevYtdSelling', label: 'Prev YTD Net Sales' }, 
                { key: 'prevYtdMrp', label: 'Prev YTD MRP' },
                { key: 'prevYtdAsp', label: 'Prev YTD ASP' }, 
                { key: 'prevYtdMdPct', label: 'Prev YTD MD%' },
                { key: 'ytdGrowthPct', label: 'YTD Growth%' },
            ];
            const csvContent = [
                columns.map(c => c.label).join(','),
                ...rows.map(row => columns.map(c => `"${row[c.key] ?? ''}"`).join(','))
            ].join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'DAILY_SALES_TRACKER_CATEGORY.csv';
            a.click();
            URL.revokeObjectURL(url);
       }
    }
    // ? API call to generate data
    const refreshData = () => {
        if (currentTab === "dailySalesTrackerCategoryLevel") {
            dispatchHandler(dispatch, 'getRefreshReportRequest', {
                viewName: 'daily_sales_tracker_data'
            }, getPermissionKey("dashboard", "performancesummary", "view"))
            return
        }
        dispatchHandler(dispatch, 'saveSiteAndItemFilterRequest', {
            filterType: "panasm",
            data: {
                end_date: dayjs().format("YYYY-MM-DD")
            }
        }, getPermissionKey("dashboard", "performancesummary", "view"))
    }
    useEffect(() => {
        getDashboardData()
    }, [currentTab])

    // Country Map Constants
    const COUNTRY_CHART_COLORS = [
        "#DED8FD", "#D4CCFD", "#C9C0FD", "#BFB4FD",
        "#B4A7FC", "#AA9BFC", "#9F8EFB", "#9482FB",
        "#8975FA"
    ];

    const [siteWiseData, setSiteWiseData] = useState({})
    const [siteWiseLoading, setSiteWiseLoading] = useState({})
    const pendingRowIndexRef = useRef(null)

    const [dataType, setDataType] = useState('salesQty')
    const getDataType = (type) => {
        setDataType(type)
    }

    // setting the dashboard data
    useEffect(() => {
        if (digivendStore?.getARSDashboardDataData?.isSuccess && digivendStore?.getARSDashboardDataData?.data?.resource) {
            let res = digivendStore?.getARSDashboardDataData?.data?.resource, temp = {};
            if (currentTab === "dsrSummary") {
                res?.dsrSummary && res?.dsrSummary?.forEach(item => {
                    if (!temp[item?.channel_wise]) {
                        temp[item?.channel_wise] = {}
                    }
                    if (!temp[item?.channel_wise][item?.store_type]) {
                        temp[item?.channel_wise][item?.store_type] = {
                            compLabels: {
                                "salesQty": "vs Previous Day",
                                "salesValue": "vs Previous Day",
                                "wtdSalesQty": "vs Previous Week",
                                "wtdSalesValue": "vs Previous Week",
                                "mtdSalesQty": `vs ${PREV_YEAR} MTD`,
                                "mtdSalesValue": `vs ${PREV_YEAR} MTD`,
                                "ytdSalesQty": `vs ${PREV_YEAR} YTD`,
                                "ytdSalesValue": `vs ${PREV_YEAR} YTD`,
                                "ytdUPT": `vs ${PREV_YEAR} YTD`,
                                "ytdATV": `vs ${PREV_YEAR} YTD`
                            }
                        }
                    }
                    temp[item?.channel_wise][item?.store_type][item?.type1 === "percentage" ? "percentages" : 'values'] = {
                        "salesQty": item?.sales_qty,
                        "salesValue": item?.retail_sales,
                        "wtdSalesQty": item?.wtd_sales_qty,
                        "wtdSalesValue": item?.wtd_retail_sales,
                        "mtdSalesQty": item?.mtd_sales_qty,
                        "mtdSalesValue": item?.mtd_retail_sales,
                        "ytdSalesQty": item?.ytd_sales_qty,
                        "ytdSalesValue": item?.ytd_retail_sales,
                        "ytdUPT": item?.ytd_upt,
                        "ytdATV": item?.ytd_atv
                    }

                });
                setDashboardData(temp);
            }
            else if (currentTab === "panIndia") {
                if (digivendStore?.getARSDashboardDataData?.data?.resource?.regionWiseContriPer) {
                    colorScale = scaleQuantile()?.domain(digivendStore?.getARSDashboardDataData?.data?.resource?.regionWiseContriPer?.map(d => d?.value))?.range(COUNTRY_CHART_COLORS);
                }
                let storeGradeContri = getStoreGradeContri(res?.storeGradeContri, dataType),
                    monthWiseSales = splitMonth(res?.monthWiseSales),
                    monthWiseASP = splitMonth(res?.monthWiseASP);
                setDashboardData({ ...res, storeGradeContri, monthWiseSales, monthWiseASP });
            }
            else if (currentTab === "asm") {
                let regionWiseSectionContriPer = [],
                    monthWiseSales = splitMonth(res?.monthWiseSales),
                    monthWisePriceTypeSales = splitMonth(res?.monthWisePriceTypeSales);
                res?.regionWiseSectionContriPer?.forEach(item => {
                    if (!temp[item?.region]) {
                        temp[item?.region] = {};
                    }
                    temp[item?.region] = { ...temp[item?.region], ...item };
                    delete temp[item?.region]?.region;
                });
                Object.keys(temp)?.forEach(key => {
                    key != "null" && regionWiseSectionContriPer?.push({
                        region: key,
                        ...temp[key]
                    });
                });
                setDashboardData({ ...res, regionWiseSectionContriPer, monthWiseSales, monthWisePriceTypeSales });
            }
            else if (currentTab === "dailySalesTracker") {
                res.dsrDetails = parseJSON(res?.dsrDetails, true);
                Object.keys(res?.dsrTotal).forEach(key => {
                    res.dsrTotal[key] = parseJSON(res?.dsrTotal?.[key], true);
                });
                setDashboardData({ ...res });
            }
            else {
                setDashboardData({ ...res });
            }
        }
    }, [digivendStore?.getARSDashboardDataData?.isSuccess, currentTab]);

    useEffect(() => {
        if (digivendStore?.getDailySalesTrackerData?.isSuccess && digivendStore?.getDailySalesTrackerData?.data) {
            const data = digivendStore.getDailySalesTrackerData.data;
            setDashboardData({
                resource: data?.resource || [],
                currPage: data?.currPage,
                maxPage: data?.maxPage,
                totalRecord: data?.totalRecord,
            });
        }
    }, [digivendStore?.getDailySalesTrackerData?.isSuccess]);

    useEffect(() => {
        if (generalStore?.getRefreshReportData?.isSuccess && currentTab === "dailySalesTrackerCategoryLevel") {
            getDashboardData();
        }
    }, [generalStore?.getRefreshReportData?.isSuccess]);

    useEffect(() => {
        const idx = pendingRowIndexRef.current;
        if (idx === null) return;
        if (digivendStore?.getSiteWiseDailySalesTrackerData?.isSuccess) {
            const resource = digivendStore.getSiteWiseDailySalesTrackerData?.data?.resource || [];
            setSiteWiseData(prev => ({ ...prev, [idx]: resource }));
            setSiteWiseLoading(prev => ({ ...prev, [idx]: false }));
        } else if (digivendStore?.getSiteWiseDailySalesTrackerData?.isError) {
            setSiteWiseLoading(prev => ({ ...prev, [idx]: false }));
        }
    }, [digivendStore?.getSiteWiseDailySalesTrackerData?.isSuccess, digivendStore?.getSiteWiseDailySalesTrackerData?.isError]);

    const getSiteWiseData = (item, index) => {
        setSiteWiseLoading(prev => ({ ...prev, [index]: true }));
        pendingRowIndexRef.current = index;
        dispatchHandler(dispatch, 'getSiteWiseDailySalesTrackerRequest', {
            displayName: "SITE_WISE_SALES_TRACKER_REPORT",
            type: "store wise",
            assortmentName: item.assortmentName
        }, getPermissionKey("dashboard", "performancesummary", "view"));
    };

    // function to get the dashboard data
    const getDashboardData = (filtersData = {}, pageNo = 1) => {
        setDashboardData([]);
        if (currentTab === "dailySalesTrackerCategoryLevel") {
            setSiteWiseData({});
            setSiteWiseLoading({});
            dispatchHandler(dispatch, 'getDailySalesTrackerRequest', {
                reportFilter: {},
                displayName: "SALES_TRACKER_REPORT",
                type: 1,
                pageNo,
                pageSize: 20,
                sortedBy: "",
                sortedIn: "",
                search: "",
                filter: filtersData || {}
            }, getPermissionKey("dashboard", "performancesummary", "view"));
            return;
        }
        let apiPayload = { filter: {}, type: tabsMapping[currentTab] }
        Object.keys(filtersData).forEach((filter) => {
            switch (filter) {
                default:
                    apiPayload.filter[filter] = filtersData[filter];
                    break;
            }
        });
        dispatchHandler(dispatch, 'getARSDashboardDataRequest', apiPayload, getPermissionKey("dashboard", "performancesummary", "view"));
    }
  
    return (
        <>
            <div className='performance-summary'>
                <div className='ps-filter-tab !grid !items-end justify-between grid-cols-[1fr_0.35fr] bg-white'> 
                    <GenericTabsComponent
                        tabsData={{
                            dsrSummary: "DSR Summary",
                            panIndia: "PAN India - YTD",
                            asm: "ASM - YTD",
                            divisionWiseSales: "Division Wise Sales",
                            dailySalesTracker: "Daily Sales Tracker",
                            dailySalesTrackerCategoryLevel: "Daily Sales Tracker Category Level",
                        }}
                        tabsKey={"currentTab"}
                        handleTabChange={(val) => {
                            setCurrentTab(val);
                        }}
                        current={currentTab}
                        type={1}
                    />
                    <div className="psf-right">
                        <span>
                            <i><LanguageTranslator>All amount values are in</LanguageTranslator> <LanguageTranslator tag="b">millions</LanguageTranslator></i>
                        </span>
                        {(currentTab === "dailySalesTracker" || currentTab === "dailySalesTrackerCategoryLevel") &&
                            <GenericCustomButton
                                className='psfr-download-btn'
                                label='Download Report'
                                onClick={exportToExcel}
                                leftIcon={<Icons.ReportDownloadIcon />}
                            />}

                        <GenericCustomButton
                            className='psfr-refresh-btn'
                            label='Refresh Data'
                            loading={digivendStore?.saveSiteAndItemFilterData?.isLoading || (currentTab === "dailySalesTrackerCategoryLevel" && generalStore?.getRefreshReport?.isLoading)}
                            onClick={refreshData}
                        />

                    </div>
                </div>

                {currentTab === 'dsrSummary' && <DSRSummary getDashboardData={getDashboardData} dsrSummaryData={dashboardData} />}
                {currentTab === 'panIndia' && <PANIndia colorScale={colorScale} getDashboardData={getDashboardData} getDataType={getDataType} dashboardData={dashboardData} />}
                {currentTab === 'asm' && <AsmYtd getDashboardData={getDashboardData} dashboardData={dashboardData} />}
                {currentTab === 'divisionWiseSales' && <DivisionWiseSales getDashboardData={getDashboardData} dashboardData={dashboardData} />}
                {currentTab === 'dailySalesTracker' && <DailySalesTracker getDashboardData={getDashboardData} dashboardData={dashboardData} />}
                {currentTab === 'dailySalesTrackerCategoryLevel' && <DailySalesTrackerCategoryLevel getDashboardData={getDashboardData} dashboardData={dashboardData} isLoading={digivendStore?.getDailySalesTrackerData?.isLoading} getSiteWiseData={getSiteWiseData} siteWiseData={siteWiseData} siteWiseLoading={siteWiseLoading} />}

            </div>
        </>
    )
}

export default PerformanceSummaryDashboard